import { render, staticRenderFns } from "./FluxRegister.vue?vue&type=template&id=49f4bccb&scoped=true&"
import script from "./FluxRegister.vue?vue&type=script&lang=js&"
export * from "./FluxRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4bccb",
  null
  
)

export default component.exports